<template>
  <div>
    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <h2 class="title">Urlaubsgutscheine für deine Wellness-Auszeit</h2>
            <div class="content">
              <p>
                Gönnen dir einen entspannenden Kurzurlaub in einem Wellnesshotel und lasse es dir gut gehen: Entspanne bei einer Massage, Schwitze in der Sauna oder Döse im Ruherau – du hast die Wahl!
              </p>
              <p>Clever & günstig reisen mit flexiblen Hotelgutscheinen, die bis zu drei Jahren gültig sind.</p>
              <p class="has-text-weight-bold">Die Urlaubsgutscheine sind zudem übertragbar und damit die perfekte Geschenkidee!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-offers has-background-white-ter">
      <div class="container">
        <div v-if="!hasOffers">
          <NoOffer />
        </div>

        <div v-if="hasOffers">
          <h2 class="title is-size-4 has-text-centered">{{ $t('product.offers-end-in') }}</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <div v-if="traveldeal.length == 1">
            <div v-for="o in traveldeal" :key="o.id">
              <Deal :product="o" v-bind:has-countdown="false" />
            </div>
          </div>

          <div class="columns is-multiline is-variable is-5" v-if="traveldeal.length > 1">
            <div class="column is-half-tablet" v-for="o in traveldeal" :key="o.id">
              <DealSmall :product="o" v-bind:has-countdown="false" />
            </div>
          </div>

          <div class="columns is-multiline is-variable is-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" />
            </div>
          </div>

          <p class="has-text-centered has-text-weight-bold mt-5">{{ $t('product.more-offer-wait') }}</p>
          <div class="has-text-centered mt-3">
            <b-button tag="router-link" to="/" type="is-dark">
              {{ $t('product.go-to-all-offers') }}
            </b-button>
          </div>
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>
  </div>
</template>

<script>
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
//import HeroBadge from '@/components/HeroBadge'
import OfferApi from '@/api/offer-api'
import Deal from '@/components/Deal'
import DealSmall from '@/components/DealSmall'
import promotion from '@/common/promotion'

const NoOffer = () => import(/* webpackPrefetch: true , webpackChunkName: "nooffer" */ '@/components/NoOffer')

export default {
  name: 'italia',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
    //HeroBadge,
    NoOffer,
    Deal,
    DealSmall,
  },
  data() {
    return {
      offers: [],
      traveldeal: [],
      promotionEndDate: '',
      hasOffers: false,
    }
  },
  computed: {
    campaignTimer: function() {
      //let endDate = new Date('2022-03-06 23:59') - new Date()
      let endDate = this.promotionEndDate - new Date()
      return endDate
    },
  },
  methods: {
    isTravelDeal(f) {
      return promotion.hasActivePromotion('TravelDeal', f)
    },
  },
  async mounted() {
    let offers = await OfferApi.getOffersWithCustomPromotion('wellness')
    this.offers = offers.filter(item => !this.isTravelDeal(item))

    this.traveldeal = offers.filter(item => this.isTravelDeal(item))

    this.promotionEndDate = promotion.getEndDateForPromotionOnly('Custom:wellness', this.$store.getters.promotions)

    this.hasOffers = this.offers.length > 0 || this.traveldeal.length > 0
  },
  metaInfo() {
    return {
      title: 'Urlaubsgutscheine für deine Wellness-Auszeit',
      meta: [{name: 'description', content: 'Genieße einen erholsamen Wellness Kurzurlaub. Clever & günstig reisen mit Urlaubsgutschein.'}],
    }
  },
}
</script>

<style lang="scss"></style>
